<template>
  <router-view />
</template>

<script>
export default {
  name: "WorkGroupSingle"
}
</script>